import FileUpload from "../../../common/fileUpload";

const ImportUsersForm = ({
  onFileSelect,
  onClear,
  uploadDetails,
  fileName,
}) => {
  return (
    <FileUpload
      shouldManualUpload={false}
      name="import_users"
      label="import_users_message"
      fileType={".xlsx"}
      onUpload={onFileSelect}
      uploadDetails={uploadDetails?.[fileName]}
      onClear={onClear}
    />
  );
};

export default ImportUsersForm;
